import script from "./ChangePassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangePassword.vue?vue&type=script&lang=ts&setup=true"

import "./ChangePassword.vue?vue&type=style&index=0&id=1f340ef7&lang=less&scoped=true"

import exportComponent from "/var/build/production/tenants-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f340ef7"]])

export default __exports__